import React from "react";
import Loader from "../../Common/Loader";

function StudentAccessLogs({studentAccessLogs, loading2}) {

    return (
        <>
            <div className="border-top mt-1"></div>
            <div className="table-responsive">
                {loading2 ? (
                    <Loader />
                ) : (
                    <table className="table display data-table text-nowrap">
                        <thead>
                            <tr>
                            <th scope="col">Date & Time</th>
                            <th scope="col">Log Image</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentAccessLogs.length > 0 ? (
                                studentAccessLogs.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {item.created_at.long_date} 
                                    </td>

                                    
                                    <td><img
                        alt="avatar"
                        style={{maxHeight: "80px", maxWidth: "80px"}}
                        src={item.log_image}
                      /></td>
                                    
                                </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: "center" }}>
                                        No student access logs yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </>

        
    );
}

export default StudentAccessLogs;
